import $ from 'jquery';
import { Application as MarionetteApp } from 'marionette';

import RetailManager from 'app/retail_manager/RetailManager';
import RegisterController from 'app/src/controllers/RegisterController';
import SettingsController from 'app/src/controllers/SettingsController';
import CommonData from 'app/src/data/CommonData';
import Localize from 'app/src/localize/Localize';
import PaymentTypeManager from 'app/src/payments/PaymentTypeManager';

export default class Application extends MarionetteApp {
  /**
   * Initialize the Application.  This is used to invoke any asynchronous operations that
   * need to be resolved before the application starts.
   *
   * @returns {*}
   */
  init() {
    let deferred = $.Deferred();

    // add asynchronous dependencies here
    CommonData.init()
      .then(() => {
        // Other modules may depend on common data so make sure it gets
        // initialized first

        RetailManager.init();

        $.when(Localize.init(), PaymentTypeManager.init())
          .done(() => {
            this._initialized = true;
            deferred.resolve();
          })
          .fail(() => {
            deferred.reject();
          });
      })
      .fail((jqXHR) => {
        switch (jqXHR.status) {
          case 403:
            // A 403 could happen in the case where the account has expired
            // That's expected so just resolve the promise
            deferred.resolve();
            break;

          default:
            deferred.reject();
            break;
        }
      });

    return deferred.promise();
  }

  /**
   * Loads the high-level controllers that need to be resolved when the application starts.
   */
  loadDefaultControllers() {
    this._register = new RegisterController();
    this._settings = new SettingsController();
  }

  /**
   * Temporary method used until this client-api subsumes all payment responsibilities.  T
   */
  get enabled() {
    return this._initialized;
  }
}
